(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delacallepdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getSwatchData(btn) {
    try { return JSON.parse(btn.dataset.productJson || '{}'); } catch (e) { return {}; }
  }

  function initProductHeroBlob(root) {
    if (root.dataset.phInitialized === 'true') return;
    root.dataset.phInitialized = 'true';

    var mainImg = root.querySelector('.ph-main-img');
    var thumbsWrap = root.querySelector('.ph-thumbs');
    var titleEl = root.querySelector('.ph-flavor-name');
    var form = root.querySelector('.ph-product-form');
    var variantInput = form.querySelector('input[name="id"]');
    var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    var atcBtn = root.querySelector('.ph-btn--atc');
    var qtyInput = root.querySelector('.ph-qty-input');
    var swatches = root.querySelectorAll('.ph-swatch');
    var btnPrev = root.querySelector('.ph-arrow--prev');
    var btnNext = root.querySelector('.ph-arrow--next');
    var toggleWrap = root.querySelector('.ph-purchase-toggle');
    var frequencyWrap = root.querySelector('.ph-frequency-wrap');
    var frequencySel = root.querySelector('.ph-frequency-select');
    var priceTotal = root.querySelector('.ph-price-total');
    var priceCompare = root.querySelector('.ph-price-compare');
    var priceUnit = root.querySelector('.ph-price-unit');
    var announcer = root.querySelector('[data-ph-announce]');

    var unitLabel = root.dataset.unitLabel || 'lattina';
    var atcLabel = root.dataset.atcLabel || 'Aggiungi al carrello';
    var atcIcon = root.dataset.atcIcon || '🛒';
    var subLabel = root.dataset.atcSubLabel || 'Abbonati al carrello';
    var subIcon = root.dataset.atcSubIcon || '🔁';
    var soldoutLabel = root.dataset.soldoutLabel || 'Esaurito';

    var gallery = [];
    var currentIndex = 0;

    function updatePrice(priceFormatted, compareFormatted, unitFormatted) {
      if (!priceTotal) return;
      priceTotal.style.opacity = '0';
      setTimeout(function () {
        priceTotal.textContent = priceFormatted || '';
        priceTotal.style.opacity = '1';
        if (compareFormatted && compareFormatted !== priceFormatted) {
          priceCompare.textContent = compareFormatted;
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
        if (unitFormatted) {
          priceUnit.innerHTML = '<strong>' + unitFormatted + '</strong>&nbsp;/ ' + unitLabel;
          priceUnit.style.display = '';
        } else {
          priceUnit.style.display = 'none';
        }
      }, 180);
    }

    root.querySelector('.ph-qty-minus').addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    root.querySelector('.ph-qty-plus').addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    if (toggleWrap) {
      var toggleBtns = toggleWrap.querySelectorAll('.ph-toggle-btn');
      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggleBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          var isSub = btn.dataset.type === 'subscribe';
          if (frequencyWrap) frequencyWrap.classList.toggle('is-visible', isSub);
          if (sellingPlanInput) sellingPlanInput.value = isSub && frequencySel ? frequencySel.value : '';
          if (atcBtn && !atcBtn.disabled) {
            atcBtn.innerHTML = isSub
              ? subIcon + '&nbsp;' + subLabel
              : atcIcon + '&nbsp;' + atcLabel;
          }
        });
      });
      if (frequencySel) {
        frequencySel.addEventListener('change', function () {
          var active = toggleWrap.querySelector('.ph-toggle-btn.is-active');
          if (sellingPlanInput && active && active.dataset.type === 'subscribe') {
            sellingPlanInput.value = frequencySel.value;
          }
        });
      }
    }

    function applyImageMode(i) {
      i === 0 ? mainImg.classList.remove('is-fill') : mainImg.classList.add('is-fill');
    }

    function setMainImage(index) {
      if (!gallery.length) return;
      index = Math.max(0, Math.min(index, gallery.length - 1));
      currentIndex = index;
      mainImg.classList.add('is-fading');
      setTimeout(function () {
        mainImg.src = gallery[index].src;
        mainImg.alt = gallery[index].alt;
        applyImageMode(index);
        mainImg.classList.remove('is-fading');
      }, 220);
      if (thumbsWrap) {
        thumbsWrap.querySelectorAll('.ph-thumb').forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
        });
      }
      if (btnPrev) btnPrev.disabled = index === 0;
      if (btnNext) btnNext.disabled = index === gallery.length - 1;
    }

    function loadGallery(images) {
      gallery = images || [];
      currentIndex = 0;
      if (thumbsWrap) {
        thumbsWrap.innerHTML = '';
        var show = gallery.length > 1;
        thumbsWrap.style.display = show ? 'flex' : 'none';
        if (btnPrev) btnPrev.style.display = show ? '' : 'none';
        if (btnNext) btnNext.style.display = show ? '' : 'none';
        gallery.forEach(function (item, i) {
          var img = document.createElement('img');
          img.className = 'ph-thumb' + (i === 0 ? ' is-active' : '');
          img.src = item.thumb || item.src;
          img.alt = item.alt;
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          img.addEventListener('click', function () { setMainImage(i); });
          thumbsWrap.appendChild(img);
        });
      }
      applyImageMode(0);
      setMainImage(0);
    }

    function loadSellingPlans(handle) {
      if (!frequencySel) return;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var options = [];
          (data.selling_plan_groups || []).forEach(function (spg) {
            (spg.selling_plans || []).forEach(function (sp) {
              options.push('<option value="' + sp.id + '">' + sp.name + '</option>');
            });
          });
          frequencySel.innerHTML = options.length ? options.join('') : '<option value="">—</option>';
          if (!options.length && toggleWrap) {
            var oneTime = toggleWrap.querySelector('[data-type="one-time"]');
            if (oneTime) oneTime.click();
          }
        })
        .catch(function () {});
    }

    function emitSwatchChange(handle, data) {
      document.dispatchEvent(new CustomEvent('ph:swatch:change', {
        detail: { handle: handle, description: data.description || '', ingredienti: data.ingredienti || '' }
      }));
    }

    function announce(msg) {
      if (!announcer) return;
      announcer.textContent = '';
      setTimeout(function () { announcer.textContent = msg; }, 50);
    }

    function updateColors(bg, blob) {
      if (bg) root.style.setProperty('--ph-bg', bg);
      if (blob) root.style.setProperty('--ph-accent', blob);
    }

    function updateTitle(t) {
      if (!titleEl || !t) return;
      titleEl.style.opacity = '0';
      setTimeout(function () { titleEl.textContent = t; titleEl.style.opacity = '1'; }, 200);
    }

    function updateATC(vid, available) {
      if (variantInput) variantInput.value = vid;
      if (sellingPlanInput) sellingPlanInput.value = '';
      if (toggleWrap) {
        toggleWrap.querySelectorAll('.ph-toggle-btn').forEach(function (b) {
          var isOneTime = b.dataset.type === 'one-time';
          b.classList.toggle('is-active', isOneTime);
          b.setAttribute('aria-pressed', isOneTime ? 'true' : 'false');
        });
        if (frequencyWrap) frequencyWrap.classList.remove('is-visible');
      }
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.innerHTML = available
          ? atcIcon + '&nbsp;' + atcLabel
          : soldoutLabel;
      }
      if (qtyInput) qtyInput.value = 1;
    }

    var firstSwatch = root.querySelector('.ph-swatch[data-is-current="true"]');
    if (firstSwatch) {
      var initData = getSwatchData(firstSwatch);
      gallery = initData.images || [];
      if (thumbsWrap) {
        thumbsWrap.querySelectorAll('.ph-thumb').forEach(function (t, i) {
          t.addEventListener('click', function () { setMainImage(i); });
        });
        var show = gallery.length > 1;
        thumbsWrap.style.display = show ? 'flex' : 'none';
        if (btnPrev) btnPrev.style.display = show ? '' : 'none';
        if (btnNext) btnNext.style.display = show ? '' : 'none';
      }
      if (btnPrev) btnPrev.disabled = true;
      if (btnNext) btnNext.disabled = gallery.length <= 1;
      applyImageMode(0);
      emitSwatchChange(firstSwatch.dataset.handle, initData);
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { setMainImage(currentIndex - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { setMainImage(currentIndex + 1); });

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-pressed') === 'true') return;
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');

        var data = getSwatchData(btn);

        updateColors(btn.dataset.bgColor, btn.dataset.blobColor);
        updateTitle(btn.dataset.title);
        updateATC(btn.dataset.variantId, btn.dataset.available === 'true');
        updatePrice(btn.dataset.priceFormatted, btn.dataset.compareFormatted, btn.dataset.unitPriceFormatted);

        loadSellingPlans(btn.dataset.handle);
        window.history.replaceState({}, '', '/products/' + btn.dataset.handle);
        loadGallery(data.images || []);
        emitSwatchChange(btn.dataset.handle, data);
        announce(btn.dataset.title);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.product-hero-blob-section').forEach(initProductHeroBlob);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-viki"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var TRANSITION_MS = 280;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openItem(details) {
    var answer = details.querySelector('.faq-answer');
    if (!answer) return;

    details.setAttribute('open', '');

    if (prefersReducedMotion()) return;

    var inner = answer.querySelector('.faq-answer__inner');
    var targetH = inner ? inner.scrollHeight + 16 : 0;

    answer.style.transition = 'none';
    answer.style.maxHeight = '0px';

    requestAnimationFrame(function () {
      answer.style.transition = 'max-height ' + TRANSITION_MS + 'ms ease';
      answer.style.maxHeight = targetH + 'px';
    });
  }

  function closeItem(details) {
    var answer = details.querySelector('.faq-answer');
    if (!answer) return;

    if (prefersReducedMotion()) {
      details.removeAttribute('open');
      return;
    }

    answer.style.transition = 'none';
    answer.style.maxHeight = answer.scrollHeight + 'px';

    requestAnimationFrame(function () {
      answer.style.transition = 'max-height ' + TRANSITION_MS + 'ms ease';
      answer.style.maxHeight = '0px';
    });

    setTimeout(function () {
      details.removeAttribute('open');
      answer.style.maxHeight = '';
      answer.style.transition = '';
    }, TRANSITION_MS);
  }

  function attachItem(details) {
    var summary = details.querySelector('.faq-question');
    if (!summary || summary.dataset.faqBound) return;

    summary.dataset.faqBound = '1';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.hasAttribute('open')) {
        closeItem(details);
      } else {
        openItem(details);
      }
    });
  }

  function initSection(container) {
    container.querySelectorAll('.faq-item').forEach(attachItem);
  }

  function destroySection(container) {
    container.querySelectorAll('.faq-answer').forEach(function (a) {
      a.style.maxHeight = '';
      a.style.transition = '';
    });
  }

  document.querySelectorAll('.faq-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.faq-section');
    if (sec) initSection(sec);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target.querySelector('.faq-section');
    if (sec) destroySection(sec);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var details = e.target;
    if (details && details.classList.contains('faq-item') && !details.hasAttribute('open')) {
      openItem(details);
    }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var details = e.target;
    if (details && details.classList.contains('faq-item') && details.hasAttribute('open')) {
      closeItem(details);
    }
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-menu-custom-viki"] && !Shopify.designMode) return;
  try {
    
(function() {
  var BREAKPOINT = 769;

  function closeOnMobile() {
    if (window.innerWidth < BREAKPOINT) {
      document.querySelectorAll('[data-footer-accordion]').forEach(function(el) {
        el.removeAttribute('open');
      });
    }
  }

  function debounce(fn, delay) {
    var t;
    return function() { clearTimeout(t); t = setTimeout(fn, delay); };
  }

  closeOnMobile();
  window.addEventListener('resize', debounce(closeOnMobile, 150));

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId === '{{ section.id }}') closeOnMobile();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspots-viki-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * @typedef {{ overlay: Element, modal: Element, trigger: Element|null }} ModalRefs
   */

  /** @type {Map<string, ModalRefs>} */
  const registry = new Map();

  /** @type {string|null} */
  let activeModalId = null;

  /** @type {Element|null} */
  let lastTrigger = null;

  // ── Focus trap helpers ──────────────────────────────────────────────────

  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  /**
   * Trap Tab / Shift+Tab focus inside the modal element.
   * @param {KeyboardEvent} event
   * @param {Element} modal
   */
  function trapFocus(event, modal) {
    const focusable = Array.from(modal.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;

    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  // ── Open / close ────────────────────────────────────────────────────────

  /**
   * @param {string} modalId
   * @param {Element} trigger
   */
  function openModal(modalId, trigger) {
    if (activeModalId) closeModal(activeModalId, false);

    const refs = registry.get(modalId);
    if (!refs) return;

    activeModalId = modalId;
    lastTrigger   = trigger;

    refs.modal.classList.add('is-active');
    refs.overlay.classList.add('is-active');
    refs.modal.setAttribute('aria-hidden', 'false');
    refs.overlay.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    // Focus titolo modale
    const titleEl = refs.modal.querySelector('[id$="-title"]');
    if (titleEl) {
      titleEl.focus();
    }

    document.addEventListener('keydown', handleKeydown);
  }

  /**
   * @param {string} modalId
   * @param {boolean} [restoreFocus=true]
   */
  function closeModal(modalId, restoreFocus = true) {
    const refs = registry.get(modalId);
    if (!refs) return;

    refs.modal.classList.remove('is-active');
    refs.overlay.classList.remove('is-active');
    refs.modal.setAttribute('aria-hidden', 'true');
    refs.overlay.setAttribute('aria-hidden', 'true');

    const trigger = refs.trigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && lastTrigger) lastTrigger.focus();

    activeModalId = null;
    lastTrigger   = null;
    document.removeEventListener('keydown', handleKeydown);
  }

  // ── Event handlers ───────────────────────────────────────────────────────

  /** @param {KeyboardEvent} event */
  function handleKeydown(event) {
    if (!activeModalId) return;
    const refs = registry.get(activeModalId);

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(activeModalId);
      return;
    }

    if (event.key === 'Tab' && refs) {
      trapFocus(event, refs.modal);
    }
  }

  // ── Init / destroy per section ───────────────────────────────────────────

  /**
   * @param {Element} sectionEl
   */
  function init(sectionEl) {
    // Hotspot triggers
    sectionEl.querySelectorAll('[data-hotspot-trigger]').forEach((btn) => {
      const modalId = btn.dataset.hotspotTrigger;
      const modal   = document.getElementById(modalId);
      const overlay = document.querySelector(`[data-modal-overlay="${modalId}"]`);

      if (!modal || !overlay) return;

      registry.set(modalId, { modal, overlay, trigger: btn });

      btn.addEventListener('click', () => openModal(modalId, btn));
    });

    // Close buttons inside modals
    document.querySelectorAll('[data-modal-close]').forEach((btn) => {
      const modalId = btn.dataset.modalClose;
      if (!registry.has(modalId)) return;

      btn.addEventListener('click', () => closeModal(modalId));
    });

    // Overlay click to close
    document.querySelectorAll('[data-modal-overlay]').forEach((overlay) => {
      const modalId = overlay.dataset.modalOverlay;
      if (!registry.has(modalId)) return;

      overlay.addEventListener('click', () => closeModal(modalId));
    });
  }

  /**
   * @param {Element} sectionEl
   */
  function destroy(sectionEl) {
    if (activeModalId) closeModal(activeModalId, false);

    sectionEl.querySelectorAll('[data-hotspot-trigger]').forEach((btn) => {
      const modalId = btn.dataset.hotspotTrigger;
      registry.delete(modalId);
    });
  }

  // ── Shopify editor events ────────────────────────────────────────────────

  document.addEventListener('shopify:section:load', (event) => {
    const sectionEl = event.target;
    if (sectionEl) init(sectionEl);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionEl = event.target;
    if (sectionEl) destroy(sectionEl);
  });

  // ── Auto-init on page load ───────────────────────────────────────────────
  document.querySelectorAll('[data-section-id]').forEach((sectionEl) => {
    if (sectionEl.querySelector('[data-hotspot-trigger]')) {
      init(sectionEl);
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ithaca-style-header"] && !Shopify.designMode) return;
  try {
    
(function () {

  function getSection(el) {
    return el.closest('[id^="shopify-section-"]') || document;
  }

  /* ── Desktop dropdowns ── */
  function initDropdowns(container) {
    container.querySelectorAll('.ih-nav__pill--dropdown').forEach(function (btn) {
      var targetId = btn.getAttribute('aria-controls');
      var menu = document.getElementById(targetId);
      if (!menu) return;

      btn.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        closeAllDropdowns(container);
        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
      });

      menu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          btn.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
          btn.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) closeAllDropdowns(container);
    });
  }

  function closeAllDropdowns(container) {
    container.querySelectorAll('.ih-nav__pill--dropdown').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var m = document.getElementById(btn.getAttribute('aria-controls'));
      if (m) m.hidden = true;
    });
  }

  /* ── Mobile menu overlay ── */
  function initMobileMenu(container) {
    var hamburger   = container.querySelector('.ih-hamburger');
    var overlay     = container.querySelector('.ih-mobile-menu');
    var closeBtn    = container.querySelector('.ih-mobile-menu__close');
    var subBtns     = container.querySelectorAll('.ih-mobile-menu__link--parent');

    if (!hamburger || !overlay) return;

    function openMenu() {
      overlay.hidden = false;
      overlay.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ih-menu-open');
      // Sposta focus al tasto chiudi
      var firstFocus = overlay.querySelector('.ih-mobile-menu__close');
      if (firstFocus) firstFocus.focus();
    }

    function closeMenu() {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ih-menu-open');
      hamburger.focus();
    }

    hamburger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // Escape chiude
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    // Sub-menu accordion mobile
    subBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        var subId  = this.getAttribute('aria-controls');
        var sub    = document.getElementById(subId);
        if (!sub) return;
        this.setAttribute('aria-expanded', String(!isOpen));
        sub.hidden = isOpen;
      });
    });
  }

  /* ── Init ── */
  function init(container) {
    initDropdowns(container);
    initMobileMenu(container);
  }

  document.querySelectorAll('.ih-header').forEach(function (header) {
    init(getSection(header));
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ih-header')) init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    document.body.classList.remove('ih-menu-open');
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viki-pdp-main-v9"] && !Shopify.designMode) return;
  try {
    
  class PdpProductMain extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-pdp-data]').textContent);
      this.variantIdInput = this.querySelector('[data-pdp-variant-id]');
      this.optionInputs = Array.from(this.querySelectorAll('.pdp__option-input'));
      this.planInputs = Array.from(this.querySelectorAll('.pdp__purchase-input'));
      this.addText = this.querySelector('[data-pdp-add-text]');
      this.addPrice = this.querySelector('[data-pdp-add-price]');
      this.addButton = this.querySelector('.pdp__add');

      this.bindMedia();
      this.bindOptions();
      this.bindPlans();
      this.update();
    }

    bindMedia() {
      const slides = Array.from(this.querySelectorAll('.pdp__slide'));
      const thumbs = Array.from(this.querySelectorAll('[data-pdp-thumb]'));
      const show = (id) => {
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === id));
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.pdpThumb === id));
      };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.pdpThumb)));

      const step = (dir) => {
        const idx = slides.findIndex((s) => s.classList.contains('is-active'));
        const next = (idx + dir + slides.length) % slides.length;
        show(slides[next].dataset.mediaId);
      };
      const prev = this.querySelector('[data-pdp-prev]');
      const next = this.querySelector('[data-pdp-next]');
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
    }

    bindOptions() {
      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.update());
      });
    }

    bindPlans() {
      this.planInputs.forEach((input) => {
        input.addEventListener('change', () => this.update());
      });
    }

    selectedOptions() {
      const map = {};
      this.optionInputs.forEach((input) => {
        if (input.checked) map[input.dataset.optionPosition] = input.value;
      });
      return map;
    }

    currentVariant() {
      if (!this.optionInputs.length) return this.data.variants[0];
      const selected = this.selectedOptions();
      return this.data.variants.find((v) =>
        v.options.every((opt, i) => selected[String(i + 1)] === opt)
      );
    }

    selectedPlan() {
      const checked = this.planInputs.find((i) => i.checked);
      if (!checked || !checked.dataset.planId) return null;
      return checked.dataset.planId;
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const parts = value.split('.');
      const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const amount = withCommas + '.' + parts[1];
      const noDecimals = withCommas;
      const dotThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const commaDecimals = dotThousands + ',' + parts[1];

      const open = '{' + '{';
      const close = '}' + '}';
      const format = this.data.moneyFormat || open + 'amount' + close;
      const token = (name, replacement) => {
        const re = new RegExp(open + '\\s*' + name + '\\s*' + close, 'g');
        return [re, replacement];
      };
      const rules = [
        token('amount_no_decimals_with_comma_separator', dotThousands),
        token('amount_with_comma_separator', commaDecimals),
        token('amount_no_decimals', noDecimals),
        token('amount', amount)
      ];
      let out = format;
      rules.forEach(([re, replacement]) => {
        out = out.replace(re, replacement);
      });
      return out;
    }

    update() {
      const variant = this.currentVariant();

      this.querySelectorAll('[data-onetime-price]').forEach((el) => {
        el.textContent = variant ? this.formatMoney(variant.price) : '';
      });
      this.planInputs.forEach((input) => {
        const planId = input.dataset.planId;
        if (!planId || !variant) return;
        const alloc = variant.plans.find((p) => String(p.id) === planId);
        const priceEl = this.querySelector('[data-plan-price="' + planId + '"]');
        if (priceEl) priceEl.textContent = alloc ? this.formatMoney(alloc.price) : '';
      });

      if (!variant) {
        this.addButton.disabled = true;
        this.addText.textContent = this.addText.dataset.unavailable || 'Unavailable';
        this.addPrice.textContent = '';
        return;
      }

      this.variantIdInput.value = variant.id;

      let price = variant.price;
      let compare = variant.compare > variant.price ? variant.compare : 0;
      const planId = this.selectedPlan();
      if (planId) {
        const alloc = variant.plans.find((p) => String(p.id) === planId);
        if (alloc) {
          price = alloc.price;
          compare = alloc.compare > alloc.price ? alloc.compare : 0;
        }
      }

      this.addButton.disabled = !variant.available;
      this.addText.textContent = variant.available
        ? this.addText.dataset.available || this.addText.textContent
        : this.addText.dataset.soldout || 'Sold out';

      let priceHtml = '• ' + this.formatMoney(price);
      if (compare) priceHtml += ' <s>' + this.formatMoney(compare) + '</s>';
      this.addPrice.innerHTML = variant.available ? priceHtml : '';
    }
  }

  if (!customElements.get('pdp-product-main')) {
    customElements.define('pdp-product-main', PdpProductMain);
  }

  document.querySelectorAll('.pdp').forEach((el) => {
    if (el.tagName.toLowerCase() !== 'pdp-product-main') {
      const wrapper = document.createElement('pdp-product-main');
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viki-slider-bento"] && !Shopify.designMode) return;
  try {
    
  class SlideshowViki extends HTMLElement {
    connectedCallback() {
      this._slides    = Array.from(this.querySelectorAll('.sv-slide'));
      this._dots      = Array.from(this.querySelectorAll('.sv-dot'));
      this._count     = this._slides.length;
      this._index     = 0;
      this._timer     = null;
      this._animating = false;
      this.autoplay   = this.dataset.autoplay === 'true';
      this.speed      = parseInt(this.dataset.speed, 10) || 5000;
      this.transition = this.dataset.transition || 'fade';
      if (this._count < 2) return;
      this.querySelector('.sv-btn--prev')?.addEventListener('click', () => this._step(-1));
      this.querySelector('.sv-btn--next')?.addEventListener('click', () => this._step(1));
      this._dots.forEach(dot => dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10))));
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  this._step(-1);
        if (e.key === 'ArrowRight') this._step(1);
      });
      if (this.autoplay) this._startAutoplay();
    }
    disconnectedCallback() { this._stopAutoplay(); }
    _step(dir) { this.goTo(this._index + dir, dir); }
    goTo(newIndex, dir = null) {
      if (this._animating) return;
      const oldIndex = this._index;
      this._index = ((newIndex % this._count) + this._count) % this._count;
      if (this._index === oldIndex) return;
      if (dir === null) dir = newIndex > oldIndex ? 1 : -1;
      const oldSlide = this._slides[oldIndex];
      const newSlide = this._slides[this._index];
      oldSlide.classList.remove('is-active');
      if (this.transition === 'slide') {
        this._animating = true;
        oldSlide.classList.add(dir > 0 ? 'is-prev' : 'is-next');
        newSlide.classList.add('is-active');
        oldSlide.addEventListener('transitionend', () => {
          oldSlide.classList.remove('is-prev', 'is-next');
          this._animating = false;
        }, { once: true });
        setTimeout(() => { oldSlide.classList.remove('is-prev', 'is-next'); this._animating = false; }, 600);
      } else {
        newSlide.classList.add('is-active');
      }
      this._updateDots();
    }
    _updateDots() {
      this._dots.forEach((dot, i) => {
        const active = i === this._index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    _startAutoplay() { this._timer = setInterval(() => this._step(1), this.speed); }
    _stopAutoplay()  { clearInterval(this._timer); this._timer = null; }
  }
  if (!customElements.get('slideshow-viki')) customElements.define('slideshow-viki', SlideshowViki);
  document.addEventListener('shopify:section:unload', e => {
    const sw = e.target.querySelector('slideshow-viki');
    if (sw) sw._stopAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viki-slider-hp-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getSectionsToRefresh() {
    var sections = [];
    document.querySelectorAll('cart-drawer-component, [id^="shopify-section-"][id*="cart"]').forEach(function (el) {
      var id = el.dataset.sectionId || (el.id ? el.id.replace('shopify-section-', '') : null);
      if (id && sections.indexOf(id) === -1) sections.push(id);
    });
    document.querySelectorAll('cart-icon-component, [data-cart-icon], cart-bubble').forEach(function (el) {
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) {
        var id = wrapper.id.replace('shopify-section-', '');
        if (sections.indexOf(id) === -1) sections.push(id);
      }
    });
    return sections;
  }

  function replaceSectionHTML(sectionId, html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newSection = doc.querySelector('#shopify-section-' + sectionId) || doc.body.firstElementChild;
    var oldSection = document.querySelector('#shopify-section-' + sectionId);
    if (newSection && oldSection) {
      oldSection.replaceWith(newSection);
      return true;
    }
    return false;
  }

  function openHorizonCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      if (typeof drawer.show === 'function') { drawer.show(); return true; }
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      var dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        try { dialog.showModal(); return true; } catch (e) {}
      }
    }
    var openers = document.querySelectorAll('[data-dialog-opener="cart-drawer"], [aria-controls="cart-drawer"]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].click();
      return true;
    }
    var icon = document.querySelector('header a[href="/cart"], header a[href$="/cart"], cart-icon-component a');
    if (icon) { icon.click(); return true; }
    return false;
  }

  function addToCart(btn) {
    var card = btn.closest('.flavour-picker__card');
    var variantId = card && card.dataset.variantId;
    if (!variantId) return;

    var sellingPlanId = card.dataset.sellingPlanId;
    var productId = card.dataset.productId;
    var selectedRadio = card.querySelector('input[type=radio]:checked');
    var isSubscribe = selectedRadio && selectedRadio.value === 'subscribe';

    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (isSubscribe && sellingPlanId && sellingPlanId !== '') {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }

    var sectionsToRefresh = getSectionsToRefresh();
    var body = { items: [item] };
    if (sectionsToRefresh.length > 0) {
      body.sections = sectionsToRefresh.join(',');
      body.sections_url = window.location.pathname;
    }

    var originalText = btn.textContent.trim();
    btn.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (data) {
        if (data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            replaceSectionHTML(id, data.sections[id]);
          });
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'flavour-picker', productVariantId: variantId, productId: productId, cartData: data }
        }));
        document.dispatchEvent(new CustomEvent('cart:added', {
          bubbles: true,
          detail: { source: 'flavour-picker', cartData: data }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: data }));

        setTimeout(openHorizonCartDrawer, 50);

        btn.textContent = '\u2713';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        console.error('[Flavour Picker] Add to cart error:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  function updateNavState(wrap) {
    var grid = wrap.querySelector('.flavour-picker__grid');
    var prev = wrap.querySelector('[data-fp-nav="prev"]');
    var next = wrap.querySelector('[data-fp-nav="next"]');
    if (!grid || !prev || !next) return;
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    var canScroll = maxScroll > 2;
    prev.classList.toggle('flavour-picker__nav--hidden', !canScroll);
    next.classList.toggle('flavour-picker__nav--hidden', !canScroll);
    if (!canScroll) return;
    prev.disabled = grid.scrollLeft <= 2;
    next.disabled = grid.scrollLeft >= maxScroll - 2;
  }

  function initSlider(wrap) {
    if (wrap.dataset.fpSliderInit) return;
    wrap.dataset.fpSliderInit = '1';
    var grid = wrap.querySelector('.flavour-picker__grid');
    if (!grid) return;
    wrap.querySelectorAll('[data-fp-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = grid.querySelector('.flavour-picker__card');
        var step = card ? card.getBoundingClientRect().width : grid.clientWidth / 3;
        grid.scrollBy({ left: btn.dataset.fpNav === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
    grid.addEventListener('scroll', function () { updateNavState(wrap); }, { passive: true });
    window.addEventListener('resize', function () { updateNavState(wrap); });
    updateNavState(wrap);
  }

  function init() {
    document.querySelectorAll('.flavour-picker__atc-btn').forEach(function (btn) {
      if (btn.dataset.fpInit) return;
      btn.dataset.fpInit = '1';
      btn.addEventListener('click', function () { addToCart(btn); });
    });
    document.querySelectorAll('.flavour-picker__slider-wrap').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
